import { validateProfile } from "../ProfileValidator.ts";
import type { SourceProfile, FieldRule } from "../types.ts";
export const imageField = (selector?: string, required = true): FieldRule => ({
  asset: true,
  ...(selector ? { selector } : {}),
  attributes: ["data-src", "data-lazy-src", "data-cfsrc", "data-original", "srcset", "src"],
  transforms: ["trim", "absolute-url"],
  required,
});
export const urlField = (selector?: string, required = true): FieldRule => ({
  ...(selector ? { selector } : {}),
  attributes: ["href"],
  transforms: ["absolute-url"],
  required,
});
export const textField = (selector?: string, required = true): FieldRule => ({
  ...(selector ? { selector } : {}),
  transforms: ["trim"],
  required,
});
export function CustomCSS(profile: SourceProfile): SourceProfile {
  return validateProfile(profile);
}
